<template>
  <div>
    <div class="container-fluid mobile-margin">
      <div class="row">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <div class="card-body card-overdue" @click="redirectToPentest()" style="cursor: pointer;">
            <div class="row" style="min-width:50px; top:0%;">
              <div class="text-start align-middle">
                <span style="font-size:16px; color:white;" class="text-stroke">Penetration Tests</span>
              </div>
            </div>
            <div class="mt-4">
              <div class="row">
                <div>
                  <div class="table-responsive">
                    <table class="table table-hover table-striped text-center">
                      <tr style="font-size: 14px;">
                          <th class="text-left">Test</th>
                          <th class="text-center">Status</th>
                          <th class="vtx-insignificant">Insignificant</th>
                          <th class="vtx-low">Low</th>
                          <th class="vtx-medium">Medium</th>
                          <th class="vtx-high">High</th>
                          <th class="vtx-veryhigh">Very High</th>
                          <th class="text-center">Total Vulnerabilities</th>
                          <th class="text-center">Actions Recommended</th>
                      </tr>
                      <tbody v-if="projectsList.length != 0">
                          <tr v-for="list in projectsList" v-bind:key="list.ID">
                            <td  class="text-start" width="20%">
                              {{ list.title }}
                            </td>
                            <td>
                            </td>
                            <td>{{ list.insignificant }}</td>
                            <td>{{ list.low }}</td>
                            <td>{{ list.medium }}</td>
                            <td>{{ list.high }}</td>
                            <td>{{ list.very_high }}</td>
                            <td>{{ list.report_total }}</td>
                            <td>{{ list.action_total }}</td>
                          </tr>
                      </tbody>

                    </table>
                  </div>
                  <div v-if="projectsList.length == 0" class="row" style="padding: 5%;">
                    <div class="text-center align-middle">
                      <p class="text-default" style="font-size: 14px;">No penetration tests have been initiated to date.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
       </div>
   </div>
 </template>

<script>
export default {
  name: 'Pentest Summary',
  props: ['organisationID', 'showProduct'],

   data() {
      return {
        projectsList: [],
      }
   },

   async created() {
    if (process.env.NODE_ENV != "development" && this.showProduct)
      await this.init()
    },

    methods: {
      init() {
        this.$axios.get(process.env.VUE_APP_API_PENTEST_URL + '/organisation/'+ this.organisationID + '/project')
        .then(res => {
            if (res.data.success) {
              this.projectsList = res.data.data
            }
        })
      },

    redirectToPentest() {
        const auth = this.$store.state.auth;
        const canAccess = auth.isPentester ||
                          auth.isPentestAdmin ||
                          auth.isSuperAdmin ||
                          auth.isOrganisationAdmin ||
                          (auth.accessType && auth.accessType === 'vertex_analyst');

        if (!canAccess) {
          return;
        }

				const pentesterUrl = localStorage.getItem('pentester_url');

				if (!pentesterUrl)
					return;

				// Open the final redirect URL in a new tab
				window.open(pentesterUrl, '_blank');
			}
    }
  }

</script>

<style>
.no-data-text {
  font-size: 0.875rem;
}

.vtx-insignificant {
  color: #fff !important;
	background-color: rgb(226, 205, 15) !important;
}

.vtx-low {
  color: #fff !important;
	background-color: rgb(241, 194, 50) !important;
}

.vtx-medium {
  color: #fff !important;
  background-color: rgb(243, 153, 77) !important;
}

.vtx-high {
    color: #fff !important;
    background-color: rgb(232, 99, 33) !important;
}

.vtx-veryhigh {
  color: #fff !important;
  background-color: rgb(235, 28, 36) !important;
}

</style>